const subscriptionState = (function states(props) {
    return {
        labelList: [],
    }
})()

export default subscriptionState;